let Config = {
  env:'production',
  API:'https://api.walletsettle.com',
  API2:'http://localhost:5000',
  MinInvoice:25,
  gtag:'AW-00000',
  Company:'Wallet Settle',
  Website:'https://walletsettle.com',
  VerifyUrl:'https://walletsettle.com/merchant_verify/'
};
module.exports = Config;